import { rgba } from 'polished';
import styled from 'styled-components';

export default styled.div`
	margin-bottom: 10px;
	padding: 10px;
	background: ${(props) => rgba(props.theme.colors.red, 0.25)};
	color: ${(props) => props.theme.colors.red};
	border-radius: 5px;
`;
